"use client";
import React from "react";

export default function PricingBasic({ data }) {
  const {
    title,
    subtitle,
    plans = [],
    background = {},
    padding = "xl",
  } = data || {};

  const bgStyle =
    background.type === "gradient"
      ? { backgroundImage: background.value }
      : background.type === "color"
        ? { backgroundColor: background.value }
        : background.type === "image"
          ? {
              backgroundImage: `url(${background.value})`,
              backgroundSize: "cover",
              backgroundPosition: "enter",
            }
          : {};

  const paddingMap = {
    sm: "py-10 px-4",
    md: "py-16 px-6",
    lg: "py-20 px-6",
    xl: "py-28 px-8",
  };

  return (
    <section
      className={`${paddingMap[padding] || "py-20 px-6"}`}
      style={bgStyle}
    >
      <div className="max-w-7xl mx-auto text-center">
        {title && (
          <h2 className="text-4xl font-bold mb-4 text-foreground">{title}</h2>
        )}
        {subtitle && (
          <p className="text-lg text-muted-foreground mb-10">{subtitle}</p>
        )}

        <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-3">
          {plans.map((plan, idx) => (
            <div
              key={idx}
              className={`border rounded-lg p-6 shadow-sm ${
                plan.highlighted
                  ? "border-primary bg-primary/5"
                  : "border-secondary bg-white"
              }`}
            >
              <h3 className="text-xl font-semibold mb-1 text-foreground">
                {plan.name}
              </h3>
              <p className="text-muted-foreground mb-4">{plan.description}</p>
              <div className="text-3xl font-bold mb-4">
                {plan.currency || "$"}
                {plan.price?.monthly ?? 0}
                <span className="text-sm text-muted-foreground"> /mo</span>
              </div>
              <ul className="mb-6 text-left text-sm space-y-2 text-foreground">
                {plan.features.map((feature, i) => (
                  <li key={i}>• {feature}</li>
                ))}
              </ul>
              {plan.button && (
                <a
                  href={plan.button.href}
                  className={`inline-block px-5 py-2 text-sm font-medium rounded-md transition ${
                    plan.button.style === "secondary"
                      ? "bg-secondary text-secondary-foreground border border-border hover:bg-secondary/80"
                      : "bg-primary text-primary-foreground hover:bg-primary/80"
                  }`}
                >
                  {plan.button.text}
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
